/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import copy from 'copy-to-clipboard'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import ModalContainer from '../ModalContainer'
import Button from '../../Button'
import { hideModal } from '../../../redux/actions'
import { useGenerateRedemptionTokenMutation } from '../../../redux/slices/listingsSlice'

export function RedemptionTokenModal({ listing }) {
  const dispatch = useDispatch()
  const [generateRedemptionToken, { isLoading }] = useGenerateRedemptionTokenMutation()

  const [redemptionToken, setRedemptionToken] = useState(null)
  const [copied, setCopied] = useState(false)

  const onClose = () => dispatch(hideModal())
  const createNewToken = async () => {
    try {
      const response = await generateRedemptionToken(listing.partnerListingId).unwrap()
      setRedemptionToken(response.token)
    } catch {
      // Leave the modal in the confirm state so the user can retry.
    }
  }
  const copyToken = () => {
    copy(redemptionToken)
    setCopied(true)
  }

  return (
    <ModalContainer
      title="Create Redemption Token"
      modal
      maxWidth="sm"
      fullWidth="false"
      actions={{
        secondaryAction: {
          label: 'Close',
          onClick: onClose,
        },
      }}
    >
      <div style={{ marginTop: '10px' }}>
        {redemptionToken ? (
          <div>
            <Typography style={{ color: '#222' }}>
              New redemption token generated successfully. This token is scoped to your partner and expires in one year. It is shown only once — copy it now, as it cannot be retrieved later.
            </Typography>
            <div style={{ cursor: 'pointer', justifyContent: 'center' }} onClick={() => copyToken(redemptionToken)}>
              <Typography style={{
                marginTop: '25px', padding: '8px', border: 'solid #e3e3e3 1px', borderRadius: '3px', background: '#f7f7f7', color: '#2a2d36', fontFamily: 'monospace', alignItems: 'center', whiteSpace: 'nowrap', overflowX: 'scroll',
              }}
              >
                {redemptionToken}
              </Typography>
            </div>
            {copied && (
            <Typography style={{ margin: '0px' }}>
              <small>Token copied to clipboard</small>
            </Typography>
            )}
          </div>
        ) : (
          <div>
            <Typography style={{ color: '#222', marginBottom: '20px' }}>
              Generate a partner-scoped redemption token? The value is shown only once and cannot be retrieved afterward. Existing tokens remain valid until they expire.
            </Typography>
            <Button
              label={isLoading ? 'Generating…' : 'Create'}
              icon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
              fullWidth={false}
              disabled={isLoading}
              style={{ backgroundColor: '#f44336', color: 'white' }}
              onClick={() => createNewToken(listing)}
            >
              Create
            </Button>
          </div>
        )}
      </div>
    </ModalContainer>
  )
}

RedemptionTokenModal.propTypes = {
  listing: PropTypes.shape({
    partnerListingId: PropTypes.string.isRequired,
  }).isRequired,
}

export default RedemptionTokenModal
